/*
 * Multidropdown selection component
 * extends the regular Dropdown Selection
 */

import React from "react";
import { Mode } from "../common.jsx";
import Setting from "./setting.jsx";
import ReactSelectSelection from './react_select_selection.jsx';
import Select from "../../common/Select.jsx";
import Tooltip from "../../common/Tooltip.jsx";

export default class MultiDropdownSelection extends ReactSelectSelection {
    static get TYPE() {
        return "multi_dropdown_selection";
    }

    static icon() {
        return <i className="fa fa-caret-down"></i>;
    }

    // Don't confirm when adding new values, but only when option goes missing
    selectionCleared(currentValue, newValue) {
      if (currentValue == null) return false;
      if (newValue == null) return true;
      if (currentValue.length > newValue.length) return true;

      return false;
    }

    renderView() {
        return (
            <div name={this.fullFieldName(true)}>
                {this.getLockedInformationTooltip(this.modeFillOrView() && this.isReadOnlyPrefilledAnswer(), <>
                    <label className={this.props.content.label_hidden ? 'hidden-label': ''}>
                        <span className="field-label">{this.getText('label')}</span>
                        {this.props.content.required ? " *" : null}
                        {this.helpIcon()}
                        {this.renderPrefillIcon()}
                        {this.renderOptions()}
                    </label>
                    {this.descriptionText()}
                    {!this.modeFillOrView() && this.isReadOnlyAnswer() ? this.lockedInformationDefault() : ''}
                </>)}
            </div>
        );
    }

    renderSettings() {
        return (
            <div>
                {super.renderSettings()}
                <Setting.TextField
                    name="limitMax"
                    label={I18n.t('field_limit_max', {scope: 'fe'})}
                    description={I18n.t('field_limit_max_description', {scope: 'fe'})}
                    value={this.props.content.limitMax}
                    onChange={this.updateSettings}
                />
            </div>
        );
    }

    renderOptions() {
        const maxReached = this.props.content.limitMax > 0 && this.getSelected().length >= this.props.content.limitMax;
        let options = this.getOptions().map((o, i) => {
            return {
                label: this.getOptionText(o),
                value: o.value,
                disabled: maxReached,
            };
        });

        if (this.props.pdf) {
            return (
                <div className="printable-select">
                    {this.getSelectedOptions()
                        .map((o) => this.getOptionText(o))
                        .join(", ")}
                </div>
            );
        }

        return (
            <div style={{ position: "relative" }}>
                {this.getSelected().map((s) => <input key={s} type="hidden" name={this.fullFieldName(true)} value={s} />)}
                <Tooltip
                    active={maxReached && this.props.mode == Mode.FILL && !this.isReadOnlyAnswer()}
                    className="w-100"
                    title={I18n.t("checkbox_max_selections", { scope: "fe", locale: this.props.language, amount: this.props.content.limitMax }).replace(
                        "%{amount}",
                        this.props.content.limitMax
                    )}
                >
                    <Select
                        className={`multi-select-dropdown ${this.getInputClassNames()}`}
                        value={this.getSelected()}
                        readOnly={this.props.mode != Mode.FILL}
                        disabled={(this.props.mode == Mode.FILL && this.isReadOnlyAnswer()) || this.props.disabled}
                        onChange={this.onChange}
                        options={options}
                        autoComplete={this.getAutoComplete()}
                        isMulti
                    />
                </Tooltip>
            </div>
        );
    }
}
